var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 33,
    viewBox: "0 0 26 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-44.4%",
    y: "-16%",
    width: "188.9%",
    height: "164%",
    filterUnits: "objectBoundingBox",
    id: "cktd6u2xza"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M694 494c-4.963 0-9 4.062-9 9.054 0 6.196 8.054 15.291 8.397 15.676.322.36.884.36 1.206 0 .343-.385 8.397-9.48 8.397-15.676 0-4.992-4.037-9.054-9-9.054zm0 13.61c-2.497 0-4.528-2.044-4.528-4.556s2.031-4.555 4.528-4.555c2.497 0 4.528 2.043 4.528 4.555 0 2.512-2.031 4.555-4.528 4.555z",
    id: "93yjb8ghsb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-681 -494)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#cktd6u2xza)",
    xlinkHref: "#93yjb8ghsb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F6B119",
    xlinkHref: "#93yjb8ghsb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.32202dbdafa20dc8ebaeb0557fa40b35.svg";
export { ForwardRef as ReactComponent };